module.exports = __webpack_public_path__ + "img/hz6.5402fd03.png";